export default __webpack_public_path__ + "2aef5478622ddb2d558a5046fa08433f.png";